exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-scroll-to-top[data-v-0fa9dd32]{position:fixed;bottom:5%;z-index:99;opacity:0;transition:all .5s ease}.btn-scroll-to-top[data-v-0fa9dd32],[dir] .btn-scroll-to-top[data-v-0fa9dd32]{-webkit-transition:all .5s ease}[dir=ltr] .btn-scroll-to-top[data-v-0fa9dd32]{right:30px}[dir=rtl] .btn-scroll-to-top[data-v-0fa9dd32]{left:30px}.btn-scroll-to-top.show[data-v-0fa9dd32]{opacity:1}", ""]);

// exports
